<template>
    <div class="card">
        <div class="card-body" style="padding: 0px;">
            <div class="row">
                <div class="col-2">
                    <div class="card">
                        <div class="card-header" style="min-height: 62px; padding: 0 1.5rem;">
                            <div class="card-title">
                                <span style="color: #306b84; font-weight: bold">หมวดสินค้า</span>  
                            </div>
                            <div class="card-toolbar">
                            </div>
                        </div>
                        <div class="card-body" style="padding: 0px;">
                            <el-input v-model="searchCategory" placeholder="ค้นหาหมวด" clearable />          
                            <div v-bind:style="{ height: windowHeight + 'px'}" style="overflow-y: scroll;">          
                                <el-menu
                                    default-active="1"
                                    class="el-menu-vertical-demo"
                                >
                                    <div v-for="(item, index) in productCategory.filter(
                                    (data) =>
                                    !searchCategory ||
                                    data.productCategoryName.toLowerCase().includes(searchCategory.toLowerCase()))" :key="index">
                                        <el-menu-item :index="index + 1" @click="selectedCategory(item)">{{ item.productCategoryName }}</el-menu-item>
                                    </div>             
                                </el-menu>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-10">
                    <div class="card">
                        <div class="card-header" style="min-height: 62px; padding: 0 1rem;">
                            <div class="card-title">
                                <el-select
                                v-model="selectedShowProduct"
                                collapse-tags
                                style="text-align: left;"
                                id="textLeft"
                                >
                                    <el-option
                                    v-for="item in showProductOption"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value"
                                    >
                                    </el-option>            
                                </el-select>  
                                    &nbsp;&nbsp;  
                                    <el-select
                                    v-model="isShowProduct"
                                    collapse-tags
                                    style="width: 150px;"
                                    id="textLeft"
                                    >
                                        <el-option
                                        v-for="item in showProductionType"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value"
                                        >
                                        </el-option>            
                                    </el-select>                                
                                <div style="margin-left: 10px">
                                <label style="color: #909399">หนา </label>
                                &nbsp;
                                    <el-input-number
                                    v-model="thicknessFrom"
                                    :precision="2"
                                    controls-position="right"
                                    @click="handleClickInput"
                                    @focus="$event.target.select()"
                                    style="width: 50px; height: 40px"
                                    ref="thicknessFrom"
                                    id="textRight"
                                    />
                                    &nbsp;
                                    <label style="color: #909399">ถึง </label>   
                                    &nbsp;
                                    <el-input-number
                                    v-model="thicknessTo"
                                    :precision="2"
                                    controls-position="right"
                                    @click="handleClickInput"
                                    @focus="$event.target.select()"
                                    style="width: 50px; height: 40px"
                                    ref="thicknessTo"
                                    id="textRight"
                                    />              
                                    &nbsp;
                                    <el-checkbox v-model="isRMoreThanZero" label="R>0" size="large"></el-checkbox>                   
                                <button
                                    style="margin-left: 20px;"
                                    class="btn btn-primary py-3 px-5"
                                    @click="getProduct"
                                >
                                    <i class="fa fa-search"></i>
                                </button>                                         
                                </div>                                                              
                            </div>
                            <div class="card-toolbar">
                                <div class="d-flex align-items-center position-relative my-1">
                                    <span class="svg-icon svg-icon-1 position-absolute ms-6">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                >
                                <rect
                                    opacity="0.5"
                                    x="17.0365"
                                    y="15.1223"
                                    width="8.15546"
                                    height="2"
                                    rx="1"
                                    transform="rotate(45 17.0365 15.1223)"
                                    fill="black"
                                />
                                <path
                                    d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                                    fill="black"
                                />
                                    </svg>
                                </span>
                            <el-input
                                type="text"
                                v-model="search"
                                class="w-200px"
                                placeholder="ค้นหาสินค้า"
                                clearable
                            />
                                </div>
                            </div>
                        </div>
                        <div class="card-body" style="padding: 0px;">
                            <div class="row" style="margin-top: 3px;">
                                <div class="col-10">
                                    <div style="padding: 4px; text-align: center; float: left;" >
                                        <label style="font-weight: bold;">Size : </label>&nbsp;
                                        <span v-bind:class="[checkSize == 'All' ? 'SelectSize' : 'NotSelectSize']" style="border-radius: 15px; cursor: pointer; padding: 2px 8px;" @click="selectedSizes('All')">
                                            <span style="font-size: 15px; padding: 5px 0px;">All</span>
                                        </span>
                                    </div>
                                    <div v-for="size in sizes" :key="size.id" style="padding: 4px; text-align: center; float: left; margin-bottom: 0px;">
                                        <span style="border-radius: 15px; padding: 2px 8px; cursor: pointer;" v-bind:class="[checkSize == size.name ? 'SelectSize' : 'NotSelectSize']" @click="selectedSizes(size.name)">
                                            <span style="font-size: 15px; padding: 5px 0px;">{{size.name}}</span>
                                        </span>
                                    </div>                                                                                                       
                                </div>
                            </div>
                            <el-table
                            :data="
                                products.filter(
                                    (data) =>
                                    !search ||
                                    data.productName.toLowerCase().includes(search.toLowerCase()) ||
                                    data.productCode.toLowerCase().includes(search.toLowerCase()) 
                                )
                            "
                            style="width: 100%"
                            :height="windowHeight"
                            :cell-style="{padding: '0', height: '35px'}"
                            @selection-change="handleSelectionChange"
                            highlight-current-row
                            >     
                            <el-table-column type="selection" width="45" />    
                            <el-table-column prop="productCode" label="รหัสสินค้า" width="180" sortable>
                                <template v-slot="scope">
                                    <span style="color: #009ef7; font-weight: bold; cursor: pointer"
                                    @click="callPriceHistory(scope.row.productID)"
                                    >{{ scope.row.productCode }}</span
                                    >
                                </template>            
                            </el-table-column> 
                            <el-table-column prop="productName" label="ชื่อสินค้า" sortable>
                                <template v-slot="scope">
                                    <span
                                    >{{ scope.row.productName }}</span
                                    >
                                </template>            
                            </el-table-column> 
                            <!-- <el-table-column prop="stockSK" label="Stock SK / KR" width="140" align="right" sortable>
                                <template v-slot="scope">
                                {{numberWithCommas(scope.row.stockSK,0)}} / {{numberWithCommas(scope.row.stockKR,0)}}
                                </template>                                
                            </el-table-column>-->
                            <el-table-column prop="stock" label="สต๊อก" width="140" align="right" sortable>
                                <template v-slot="scope">
                                    {{numberWithCommas(scope.row.stock,0)}}
                                </template>                                
                            </el-table-column>        
                            <el-table-column prop="productUsage" label="ค่า R" width="100" align="center" sortable>
                                <template v-slot="scope">
                                {{
                                numberWithCommas(scope.row.productUsage,2)
                                }}
                                </template>                                
                            </el-table-column> 
                            <el-table-column prop="branchCallName" label="สาขา" align="center" sortable>
                                <template v-slot="scope">
                                    <span v-if="scope.row.branchID ==1" class="badge bg-primary">
                                        {{ scope.row.branchCallName }}
                                    </span>
                                    <span v-if="scope.row.branchID ==2" class="badge bg-success">
                                        {{ scope.row.branchCallName }}
                                    </span>
                                    <span v-if="scope.row.branchID ==3" class="badge bg-info">
                                        {{ scope.row.branchCallName }}
                                    </span>
                                </template>            
                            </el-table-column>    
                            <!-- <el-table-column prop="isSelling" label="ฝากขาย" width="100" align="center" sortable>
                            <template v-slot="scope">
                                <el-switch
                                v-model="scope.row.isSelling"
                                active-color="#13ce66"
                                inactive-color="#b7b8bb"
                                @change="changeStatus(scope.row)"
                                >
                                </el-switch>
                            </template>
                            </el-table-column> -->
                            <el-table-column
                                prop="priceUpdateDatetime"
                                label="ราคาอัพเดทล่าสุด"
                                width="160"
                                sortable
                            >   
                                <template v-slot="scope">
                                    <span v-if="scope.row.priceUpdateDatetime != null">
                                        {{formatDateTimeFromISO(scope.row.priceUpdateDatetime)}}
                                    </span>
                                </template>            
                            </el-table-column>                            
                            <el-table-column
                            prop="priceDealer"
                            label="ราคา Dealer"
                            align="right"
                            width="130"
                            sortable
                            >
                                <template v-slot="scope">
                                    {{ numberWithCommas(scope.row.priceDealer) }}
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="PriceMarkUp"
                            label="Markup"
                            align="right"
                            width="100"
                            sortable
                            >
                                <template v-slot="scope">
                                    {{ numberWithCommas(scope.row.priceMarkUp) }}
                                </template>
                            </el-table-column>                            
                            <el-table-column
                            prop="pricePartner"
                            label="ราคา/กก."
                            align="right"
                            width="110"
                            >
                                <template v-slot="scope">
                                    <el-input-number
                                    v-model="scope.row.pricePartner"
                                    :precision="2"
                                    controls-position="right"
                                    @click="handleClickInput"
                                    @focus="$event.target.select()"
                                    style="width: 70px; height: 35px"
                                    ref="pricePartner"
                                    id="textRight"
                                />                
                                </template>            
                            </el-table-column>                                                                                                          
                            </el-table>
                        </div>
                        <div class="card-footer" style="padding: 0.5rem 0.25rem">
                            <div class="row">
                                <div class="col-8">
                                    <el-button type="primary" :loading="buttonLoading" @click="setPriceMulti" >กำหนดราคา</el-button>
                                    <!-- <el-button type="success" :loading="buttonLoading" @click="changeStatusMuti(true)" v-if="showButton == 0">กำหนดฝากขาย</el-button>
                                    <el-button type="danger" :loading="buttonLoading" @click="changeStatusMuti(false)" v-if="showButton == 1">ยกเลิกฝากขาย</el-button> -->
                                    <el-button :type="ButtonType" :loading="buttonLoading" @click="changeStatusMuti(selectedShowProduct)">{{ ButtonName }}</el-button>
                                </div>
                                <div class="col-4" style="text-align: right;">
                                    <el-button type="primary" @click="setPrice" :loading="buttonLoading"
                                    >บันทึกราคา</el-button
                                    >                                
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
        <loading 
        v-model:active="isLoading"
        :loader="dots" 
        :is-full-page="false"/>   
        <set-price-partner-modal
        ref="setPricePartnerModal"
        @refreshdata="getProduct"
        ></set-price-partner-modal>                 
    </div>
</template>

<script>
import ApiService from "@/core/services/ApiService";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { numberWithCommas, formatDateTimeFromISO } from "@/utils";
import Loading from 'vue-loading-overlay';
import Swal from "sweetalert2/dist/sweetalert2.js";
import Chip from '../../../components/chips/Chip.vue';
import ChipGroup from '../../../components/chips/ChipGroup.vue';
import SetPricePartnerModal from "@/components/modals/forms/SetPricePartnerModal";

export default {
    components: {
        SetPricePartnerModal,
        Loading,
        // Chip,
        // ChipGroup,
    },    
    mounted: function () {
        setCurrentPageBreadcrumbs("กำหนดสินค้าฝากขาย", []);
        this.getProductCategory();
        this.getProduct();
        this.getSize('LG');
    },    
    computed:{
        ButtonName() {
            return (this.showButton == 0) ? "กำหนดฝากขาย" : "ยกเลิกฝากขาย";
        },
        ButtonType(){
            return (this.showButton == 0) ? "success" : "danger";
        },
    },
    data(){
        return{
            windowHeight: window.innerHeight - 290,
            productCategory: [],
            mainProducts: [],
            products: [],
            search: "",
            categorySelected: "LG",
            isLoading: false,
            showProductOption: [
                {name: "รายการที่กำหนดฝากขาย", value: 1},
                {name: "รายการที่ยังไม่กำหนดฝากขาย", value: 0}
            ],   
            showProductionType: [
                {name: "แสดงเฉพาะ FG", value: "FG"},
                {name: "แสดงเฉพาะ Trade", value: "Trade"},
                {name: "แสดงทั้งหมด", value: "All"}
            ],              
            selectedShowProduct: 1,   
            thicknessFrom: null,
            thicknessTo: null, 
            isShowProduct: "FG",
            showButton: 1, 
            sizes: [],
            filter: {
                sizes: []
            },             
            isRMoreThanZero: true,   
            checkSize: "All", 
            priceLower: 0,
            priceLimit: 0,    
            searchCategory: "",    
        }
    },       
    methods:{
        getProductCategory: async function () {
            try {
                const { data } = await ApiService.query("productcategorys");

                this.productCategory = data;
            
            } catch (error) {
                console.log(error);
            }
        },   
        getProduct: async function () {
            this.isLoading = true;

            const thickFrom = this.thicknessFrom == undefined ? 0 : this.thicknessFrom;
            const thickTo = this.thicknessTo == undefined ? 0 : this.thicknessTo;

            try {
                const { data } = await ApiService.query("products/GetProduct2S?Category=" +
                this.categorySelected +
                "&ThickFrom=" +
                thickFrom +
                "&ThickTo=" +
                thickTo +
                "&State=" +
                this.selectedShowProduct +
                "&IsShowProduct=" +
                this.isShowProduct +
                "&IsRMoreThanZero=" +
                this.isRMoreThanZero );

                this.mainProducts = data;
                this.products = data;

                if(this.checkSize != 'All'){
                   this.selectedSizes(this.checkSize); 
                }
            
            } catch (error) {
                console.log(error);
            }

            this.showButton = this.selectedShowProduct;
            this.isLoading = false;
        }, 
        getSize(category) {
            ApiService.get("categories/" + category + "/sizes")
                .then( res => {
                this.sizes = res.data
                })
                .catch(() => {          
                this.$swal('error', 'error', 'error')
            })    
            this.checkSize = "All";
        },                
        selectedCategory(value){
                this.categorySelected = value.productCategoryCode;
                this.getProduct();
                this.getSize(value.productCategoryCode);
        },
        changeStatus: async function (v) {

            const products = v.productID.toString();
            const status = v.isSelling;
            this.updateIsSelling(products, status);
            
        },        
        changeStatusMuti(status){

            if(this.multipleSelection.length > 0){
                const products = this.multipleSelection.map((data) => data.productID+ "|" +data.branchID).join(",");
                this.updateIsSelling(products, !status);
            }else{
                this.$message({
                    type: "warning",
                    message: "กรุณาเลือกรายการสินค้า",
                });        
            }      

        },         
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },        
        updateIsSelling: async function(products, status){

            if(status==true){
                try {
                    const { data } = await ApiService.post("products/UpdateProductIsSelling", {
                    Products: products,
                    IsSelling: status,
                    });

                    if (data["success"] == 1) {
                    Swal.fire({
                        text: data["error_Text"],
                        icon: "success",
                        showCancelButton: false,
                        showConfirmButton: false,                  
                        allowOutsideClick: false,
                        timer: 1500,
                    }).then(() => {
                        this.getProduct();
                    });
                    } else if (data["success"] == 0) {
                    Swal.fire({
                        text: data["error_Text"],
                        icon: "warning",
                        buttonsStyling: false,
                        confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        customClass: {
                        confirmButton: "btn btn-primary",
                        },
                    }).then(() => {
                        this.getProduct();
                    });
                    }
                } catch (error) {
                    console.log(error);
                }
            }
            else
            {
                const { data } = await ApiService.query("products/CheckStockPartnerAll?Products=" + products);

                if(data.length==0){
                    try {
                        const { data } = await ApiService.post("products/UpdateProductIsSelling", {
                        Products: products,
                        IsSelling: status,
                        });

                        if (data["success"] == 1) {
                        Swal.fire({
                            text: data["error_Text"],
                            icon: "success",
                            showCancelButton: false,
                            showConfirmButton: false,                  
                            allowOutsideClick: false,
                            timer: 1500,
                        }).then(() => {
                            this.getProduct();
                        });
                        } else if (data["success"] == 0) {
                        Swal.fire({
                            text: data["error_Text"],
                            icon: "warning",
                            buttonsStyling: false,
                            confirmButtonText: "ปิด",
                            allowOutsideClick: false,
                            customClass: {
                            confirmButton: "btn btn-primary",
                            },
                        }).then(() => {
                            this.getProduct();
                        });
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
                else
                {
                        Swal.fire({
                            text: "ไม่สามารถยกเลิกฝากขาย พาร์ทเนอร์ยังมีสินค้าคงเหลือในสต็อก",
                            icon: "warning",
                            buttonsStyling: false,
                            confirmButtonText: "ปิด",
                            allowOutsideClick: false,
                            customClass: {
                            confirmButton: "btn btn-primary",
                            },
                        }).then(() => {
                            this.getProduct();
                        });          
                }                 
            }

        },
        setPrice: async function(){
        this.buttonLoading = true;

        const newPricePartner = this.products.filter(
            (data) => data.priceDefault != data.pricePartner
        );

        // newPricePartner.forEach(element => {
        //     if(element.pricePartner >= this.priceLower && element.pricePartner <= this.priceLimit){

        //     }else{

        //     }
        // });

        const priceNotInCondition = newPricePartner.filter(
            (data) => data.pricePartner < data.priceLower || data.pricePartner > data.priceLimit
        );

        if(priceNotInCondition.length == 0){
            try{
                const { data } = await ApiService.post("partners/UpdatePricePartner", {
                Products: newPricePartner
                    .map((data) => data.productID + "|" + data.pricePartner+ "|" +data.branchID)
                    .join(","),
                });

                if (data["success"] == 1) {
                        Swal.fire({
                        text: data["error_Text"],
                        icon: "success",
                        showCancelButton: false,
                        showConfirmButton: false,                  
                        allowOutsideClick: false,
                        timer: 1500,
                        }).then(() => {
                            this.getProduct();
                        });               
                    }            
            }catch (error){
                        Swal.fire({
                        text: "เกิดข้อผิดพลาด",
                        icon: "warning",
                        buttonsStyling: false,
                        confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                });
            }finally{
                console.log("success");
            }
        }
        else
        {
                Swal.fire({
                        text: "ราคาต่ำสุด = " + priceNotInCondition[0].priceLower + " บ./กก. และราคาสูงสุด = " + priceNotInCondition[0].priceLimit + " บ./กก." ,
                        icon: "warning",
                        buttonsStyling: false,
                        confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                });
        }

        this.buttonLoading = false;
        }, 
        setPriceMulti(){
            if(this.multipleSelection.length > 0){
                this.showSetPriceModal(this.multipleSelection);
            }else{
                this.$message({
                    type: "warning",
                    message: "กรุณาเลือกรายการสินค้า",
                });        
            }     
        },       
        showSetPriceModal(products){
            this.$refs.setPricePartnerModal.show(products, this.priceLower, this.priceLimit);
        },                        
        numberWithCommas,
        formatDateTimeFromISO,
        selectedSizes(sizename){
            this.checkSize = sizename;

            if(this.checkSize != "All"){
                this.products = this.mainProducts.filter((data) => data.prosizeGroup.includes(sizename.trim()));              
            }else{
                this.products = this.mainProducts;
            }   
        },  
        callPriceHistory(productID){
            this.$router.push({name: "priceHistory" , params: { productID: productID } })
        }        
    }
}
</script>

<style>
.el-menu-item{
    padding-left: 0px;
}
.el-menu-item{
    height: 40px;
    line-height: 40px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
input[type="number"] {
    -moz-appearance:textfield; /* Firefox */
}
#textRight .el-input__inner{
  text-align: right !important;
}
#textLeft .el-input__inner{
  text-align: left !important;
}
.el-input-number__decrease{
  visibility: hidden;
}
.el-input-number__increase{
  visibility: hidden;
}
.el-input-number.is-controls-right .el-input__inner{
  padding-left: 0px;
  padding-right: 0px;
  height: 40px;
}
.el-menu-item.is-active{
    color: #009ef7;
    background-color: #c0c4cc59;
    font-weight: bold;
}
.SelectSize {
    background-color: #007bff;
    border: solid #007bff 2px;
    color: white;
}
.NotSelectSize {
    background-color: #c0c4cc59;
    border: solid #c0c4cc59 2px;
    color: black;
}
.el-input__inner {
    text-align: left !important;
}
</style>